import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { DeleteRecipeAPI, ListRecipeAPI } from "./FoodManagementNewAPI";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { list_single_view } from "./FoodManagementSlice";
import store from "../../../Redux/store";
import SearchIcon from "@mui/icons-material/Search";
import CustomPagination from "../../Single Components/CustomPagination";
import CategorySearchandFilter from "../../Single Components/CategorySearchandFilter";

const RecipeFoodList = () => {
  let navigateTo = useNavigate();
  const allRecipeList = useSelector((state) => state.foodManagement.listRecipe);
  const filtereDataOptions = useSelector((state) => state.listCategory);

  // console.log(allRecipeList, "looo");
  const [IsModify, setIsModify] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [FormDataInfo, setFormDataInfo] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const totalPages = allRecipeList?.pages;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDataFromChild = (data) => {
    setFormDataInfo(data);
  };
  const handleBranchSelect = (selectedBranch) => {
    setSelectedBranch(selectedBranch);
  };
  const createNew = () => {
    localStorage.removeItem("recipe_id");
    store.dispatch(list_single_view(undefined));

    navigateTo("/userdashboard/foodManagement/recipe/create");
  };
  const handleClickRow = (row) => {
    localStorage.setItem("recipe_id", row?._id);
    navigateTo("/userdashboard/foodManagement/recipe/create");
  };
  // const deleteRecipe = (row) => {
  //   DeleteRecipeAPI({ recipeId: row._id });
  // };
  const deleteRecipe = (row) => {
  const confirmed = window.confirm("Are you sure you want to delete this recipe?");
  if (confirmed) {
    DeleteRecipeAPI({ recipeId: row._id }).then(() => {
      setIsModify((prev) => !prev); // Trigger data reload
    });
  }
};

  useEffect(() => {
    if (FormDataInfo.length !== 0) {
      let loadData =
        window.location.pathname === filtereDataOptions?.filterActive;
      ListRecipeAPI({
        category: FormDataInfo.category,
        search: FormDataInfo.search,
        index: currentPage - 1,
      });
    }
  }, [FormDataInfo, currentPage, IsModify]);

  return (
    <div className="global-page-parent-container special-items-ctn">
      <div
        className="global-white-bg-container Header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <p>Recipe</p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
          }}
           >
          <CategorySearchandFilter
            statusOptions={["Completed", "Drafted", "Available"]}
            onData={handleDataFromChild}
            isBranch={false}
            isDate={false}
            isCategory={true}
            onBranchSelect={handleBranchSelect}
          />

          <div
            className="justify-space-between"
            style={{
              gap: "0 12px",
              display: "flex",
              justifyContent: "end",
              alignItems: "end",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "9px",
              }}
            >
              <button
                className="create-button-blue"
                onClick={() => createNew()}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="global-white-bg-container">
        <div
          className="justify-space-between"
          style={{
            gap: "0 12px",
            display: "flex",
            justifyContent: "end",
            alignItems: "end",
          }}
        >
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            setFormDataInfo={setFormDataInfo}
          />
        </div>
        <hr className="global-hr" style={{ paddingTop: "10px" }} />
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {allRecipeList?.list?.map((item, index) => (
            <div
              key={index}
              className="receipe-card"
              onClick={() => handleClickRow(item)}
            >
              <div
                className="justify-space-between"
                style={{ borderBottom: "none", alignItems: "flex-start" }}
              >
                <div>
                  <p
                    className="head"
                    style={{ fontSize: "larger", margin: "0" }}
                  >
                    {item?.sequenceName}
                  </p>
                  <p style={{ marginBottom: "0", fontSize: "small" }}>Recipe</p>
                  <p
                    style={{
                      marginTop: "0",
                      color: "black",
                      fontWeight: "600",
                    }}
                  >
                    {item?.bomName}
                  </p>
                  <p style={{ marginBottom: "0", fontSize: "small" }}>
                    Product
                  </p>
                  <p
                    style={{
                      marginTop: "0",
                      color: "black",
                      fontWeight: "600",
                      marginBottom: "0px",
                    }}
                  >
                    {item.productName}
                  </p>
                </div>
                <div>
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation();
                      deleteRecipe(item);
                    }}
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecipeFoodList;
